import { useEffect, useState } from 'react'

import { getHelloSitesUrl } from 'api/utils/paths'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'

export function useCurrentUrl() {
  const {
    locale,
    router: { asPath },
  } = useRouterExtend()
  const [currentUrl, setCurrentUrl] = useState(
    () => `${getHelloSitesUrl(locale, false)}${basePath}${asPath}`,
  )
  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [asPath])
  return currentUrl
}
